import React from "react";

const RoundClockIcon = ({
    width = "18",
    height = "18",
    viewBox = "0 0 18 18",
    stroke = "#3B70EC",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 5.25V9L7.125 10.125M2.25 9C2.25 12.728 5.27205 15.75 9 15.75C12.7279 15.75 15.75 12.728 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27205 2.25 2.25 5.27208 2.25 9Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default RoundClockIcon;
